import { Component, OnInit } from '@angular/core';
import { CmsService } from '../../services/cms/cms.service';
import { ContactCenterContent, ContactFormData } from '@interfaces/contactForm.interface';

@Component({
  selector: 'app-contact-center',
  templateUrl: './contact-center.component.html',
  styleUrls: ['./contact-center.component.scss']
})
export class ContactCenterComponent implements OnInit {
  public content: ContactCenterContent;

  constructor(
    private cmsService: CmsService,
  ) {}

  public ngOnInit(): void {
    this.cmsService.loadContactCenterContent().toPromise().then(response => {
      this.content = response;
    });
  }

}
